import Link from 'next/link';
import Image from 'next/image';
import { ArrowRight } from '@/components/pages/icons';
import type { SubmenuProp } from './type';

export function DesktopSubMenu({ submenu }: SubmenuProp) {
  return (
    <nav className="hidden group-open:@lg:grid grid-cols-4 w-full border-t border-t-[#E5E7EB]">
      <Image
        src="/images/nh-submenu.webp"
        className="h-full object-cover"
        alt="logo"
        width={302}
        height={264}
      />
      <div className="col-span-3 pt-6 px-6">
        <ul className="grid grid-cols-4 gap-4 border-b border-b-[#E5E7EB] pb-6">
          {submenu.map((item) => (
            <li key={`desktop-submenu-${item.label}`}>
              <Link
                className="text-brand-text-button text-xl leading-[130%] tracking-[-0.4px] hover:brightness-90"
                href={item.url}
              >
                {item.label}
              </Link>
            </li>
          ))}
        </ul>
        <Link
          href="#"
          className="flex items-center gap-2 py-6 text-brand-button hover:text-brand-button-hover transition-colors font-semibold text-base"
        >
          <span className="underline">See all practice areas </span>
          <ArrowRight className="w-4 h-4" />
        </Link>
      </div>
    </nav>
  );
}
